import { Button, Result, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { StyledCard } from '../Login/styled';

const { Text } = Typography;

const ErrorPage = () => {
  const navigate = useNavigate();
  const [errorDetails, setErrorDetails] = useState(null);
  const { t } = useTranslation('auth');

  useEffect(() => {
    const storedError = sessionStorage.getItem('authError');
    if (storedError) {
      try {
        setErrorDetails(JSON.parse(storedError));
        sessionStorage.removeItem('authError'); // Nettoyer après lecture
      } catch (e) {
        console.error('Failed to parse stored error:', e);
      }
    }
  }, []);

  const handleNavigateToLogin = () => {
    navigate('/auth/login');
  };

  // TODO: Créer plusieurs pages d'erreur
  // en fonction de l'erreur
  // erreurs React
  // authentification

  return (
    <StyledCard>
      <Result
        style={{ background: 'white' }}
        status="error"
        title={t('error.title')}
        subTitle={
          <div>
            <p>{t('error.subtitle')}</p>
            {errorDetails && (
              <div style={{ marginTop: '16px' }}>
                <Text type="danger" strong>
                  {t('error.details')} :
                </Text>
                <div
                  style={{
                    marginTop: '8px',
                    padding: '8px',
                    backgroundColor: '#fff2f0',
                    border: '1px solid #ffccc7',
                    borderRadius: '4px',
                  }}
                >
                  <Text type="danger">
                    {errorDetails.message || t('error.unknown_error')}
                  </Text>
                  {errorDetails.details && (
                    <div style={{ marginTop: '8px' }}>
                      <Text type="secondary" style={{ fontSize: '12px' }}>
                        {typeof errorDetails.details === 'string'
                          ? errorDetails.details
                          : JSON.stringify(errorDetails.details, null, 2)}
                      </Text>
                    </div>
                  )}
                  {errorDetails.timestamp && (
                    <div style={{ marginTop: '4px' }}>
                      <Text type="secondary" style={{ fontSize: '11px' }}>
                        Timestamp:{' '}
                        {new Date(errorDetails.timestamp).toLocaleString()}
                      </Text>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        }
        extra={[
          <Button key="retry" type="primary" onClick={handleNavigateToLogin}>
            {t('error.back_to_login')}
          </Button>,
        ]}
      />
    </StyledCard>
  );
};

export default ErrorPage;
